<template>
  <li>
    <div>
      <p><b>Dụng thần</b></p>
      <p>Không có</p>
      <p>0</p>
    </div>

    <div>
      <p><b>Hỷ Thần</b></p>
      <p>Không có</p>
      <p>0</p>
    </div>

    <div>
      <p><b>Kị Thần</b></p>
      <p>Không có</p>
      <p>0</p>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ItemDungHiKy',
  props: {
  }
}
</script>

<style scoped>
</style>
